<div mat-dialog-content aria-labelledby="select-cert-type-title">
    <div class="dialog-header">
        <h3 id="select-cert-type-title">Elige el tipo de Certifirma:</h3>
      </div>

    <div class="option-buttons">
      <button 
        class="option-btn" 
        [class.selected]="selectedType === 'token'" 
        (click)="selectType('token')"
        cdkFocusInitial
        type="button">
        <img src="assets/icons/diploma.png" alt="Certifirma Digital Virtual" class="icon"/>
        <span class="label">Certifirma Digital Virtual</span>
      </button>
  
      <button 
        class="option-btn" 
        [class.selected]="selectedType === 'pkcs10'" 
        (click)="selectType('pkcs10')"
        type="button">
        <img src="assets/icons/certificado-virtual.png" alt="Certifirma Digital PKCS10" class="icon"/>
        <span class="label">Certifirma Digital PKCS10</span>
      </button>
    </div>
  
    <div class="actions">
        <button mat-raised-button class="button-secondary" (click)="cancel()">Cancelar</button>
        <button mat-raised-button class="button-primary" [disabled]="!selectedType" (click)="proceed()">Siguiente</button>
    </div>
  </div>
